import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit"
import {
    Row,
    Col,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
    Button, CardTitle, Form, Label,
} from "reactstrap"
import {withRouter} from "react-router"
import {Link} from "react-router-dom"
import Select from "react-select";
import {toast} from "react-toastify";

const DataTableMatiere = props => {
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false)
    const [id, setId] = useState("")
    // Data Table
    const [orders, setOrders] = useState([])
    const [departement, setDepartement] = useState([]);
    const [selectDepartement, setSelectDepartement] = useState("");
    const [semestre, setSemestre] = useState([
        {value: 1, label: "Semestre 1"},
        {value: 2, label: "Semestre 2"},
    ])
    const [selectSemestre, setSelectSemestre] = useState("")

    const [edit, setEdit] = useState(0);
    const [delet, setDelet] = useState(0);
    const [cloture, setCloture] = useState(0);
    const [cycle, setCycle] = useState([])
    const [selectCycle, setSelectCycle] = useState("")
    const [niveau, setNiveau] = useState([])
    const [selectNiveau, setSelectNiveau] = useState("")
    const [specialite, setSpecialite] = useState([])
    const [selectSpecialite, setSelectSpecialite] = useState("")
    var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
    var annee_id = userAuthScolarite.user.annee_id
    var user_id = userAuthScolarite.user.id
    const pageOptions = {
        loading: true,
        hidePageListOnlyOnePage: true,
        totalSize: orders.length,
        page: 1,
        nextPageText: "Suivant",
        prePageText: "Précédent",
        sizePerPage: 30,
        alwaysShowAllBtns: true,
        sizePerPageList: [
            {
                text: "10",
                value: 10,
            },
            {
                text: "20",
                value: 20,
            },
            {
                text: "30",
                value: 30,
            },
            {
                text: "All",
                value: orders.length,
            },
        ],
    }

    const NoDataIndication = () => (
        <h6 style={{textAlign: "center"}}>No record to display</h6>
    )
    const Columns = () => [
        {
            dataField: "id",
            text: "#Id",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "semestre",
            text: "Semestre",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "name",
            text: "Matière",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "module",
            text: "Module",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
          dataField: "nbr_heure_cours",
          text: "Nbh cours",
          sort: true,
          style: { textAlign: "center" },
          headerStyle: (colum, colIndex) => {
            return { textAlign: "center" }
          },
        },
        {
          dataField: "nbr_heure_td",
          text: "Nbh TD",
          sort: true,
          style: { textAlign: "center" },
          headerStyle: (colum, colIndex) => {
            return { textAlign: "center" }
          },
        },
        {
          dataField: "autres",
          text: "Nbh Autre",
          sort: true,
          style: { textAlign: "center" },
          headerStyle: (colum, colIndex) => {
            return { textAlign: "center" }
          },
        },
        {
          dataField: "nbr_heure_tp",
          text: "Nbh TP",
          sort: true,
          style: { textAlign: "center" },
          headerStyle: (colum, colIndex) => {
            return { textAlign: "center" }
          },
        },
        {
            dataField: "Modification",
            isDummyField: true,
            text: "Modification",
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
            sort: true,
            // eslint-disable-next-line react/display-name
            formatter: (cellContent, row) => (
                cloture != 1 ? (
                    edit === 1 ? (
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <Link to={"/EditMatiere?id=" + row.id}>
                                <i
                                    style={{color: "cornflowerblue", cursor: "pointer"}}
                                    className="fas fa-edit"
                                ></i>
                            </Link>
                        </div>
                    ) : (
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <i
                                style={{color: "#a7a3a3", cursor: "pointer"}}
                                className="fas fa-edit"
                            ></i>
                        </div>
                    )
                ) : (
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <i
                            style={{color: "#a7a3a3", cursor: "pointer"}}
                            className="fas fa-edit"
                            title="Année clôturée"
                        ></i>
                    </div>
                )
            ),
        },
        {
            dataField: "Suppression",
            isDummyField: true,
            text: "Suppression",
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
            sort: true,
            // eslint-disable-next-line react/display-name
            formatter: (cellContent, row) =>
                cloture != 1 ? (
                    delet === 1 ? (
                        row.etat != 0 ? (
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <i
                                    style={{color: "#ED6464", cursor: "pointer"}}
                                    onClick={() => toggle(row.id)}
                                    className="fas fa-trash-alt"
                                ></i>
                            </div>
                        ) : (
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <i
                                    style={{color: "#A7A3A3", cursor: "pointer"}}
                                    className="fas fa-trash-alt"
                                    title="Cette matiere déja utilisé"
                                ></i>
                            </div>
                        )
                    ) : (
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <i
                                style={{color: "#A7A3A3", cursor: "pointer"}}
                                className="fas fa-trash-alt"
                                title="Vouz n'avez pas d'accées"
                            ></i>
                        </div>
                    )
                ) : (
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <i
                            style={{color: "#A7A3A3", cursor: "pointer"}}
                            className="fas fa-trash-alt"
                            title="Année clôturée"
                        ></i>
                    </div>
                )
        },
    ]

    const {SearchBar} = Search

    useEffect(async () => {
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
            user.sous_menu.some(subMenu => subMenu.sous_menu === "Matière")
        );
        setEdit(typeArticleSubMenu.sous_menu[2].edit)
        setDelet(typeArticleSubMenu.sous_menu[2].delete)
        //niveau
        const resNiveau = await API.get("niveau/select").then(resNiveau => {
            setNiveau(resNiveau.data.Niveau)
        })
        const resDepartement = await API.get("departement/select").then(resDepartement => {
            setDepartement(resDepartement.data.Departement)
            setSelectDepartement("")
        })
        const res = await API.get("matiere/list").then(res => {
            setOrders(res.data.Matiere)
        })
        const resC = await API.get("cycle/select").then(resC => {
            setCycle(resC.data.Cycle)
        })
        setLoading(true)
    }, [])

    const toggle = id => {
        setModal(!modal)
        setId(id)
    }

    const toggleDelete = async () => {
        console.log("hello")
        const res = await API.post("matiere/delete", {
            id: id,user_id,annee_id
        }).then(res => {
            setModal(false)
            const resD = API.get("matiere/list").then(resD => {
                setOrders(resD.data.Matiere)
            })
            setLoading(true)
        })
    }

    useEffect(() => {
        setModal(false)
    }, [orders])
    const search = async () => {
        const specialite_id = selectSpecialite != "" && selectSpecialite != null ? selectSpecialite.value : 0;
        const departement_id = selectDepartement != "" && selectDepartement != null ? selectDepartement.value : 0;
        const semestre_id = selectSemestre != "" && selectSemestre != null ? selectSemestre.value : 0;
        const niveau_id = selectNiveau != "" && selectNiveau != null ? selectNiveau.value : 0;

        setOrders([])
        const res = await API.post("matiere/search", {
            specialite_id: specialite_id,
            departement_id: departement_id,
            semestre_id: semestre_id,
            niveau_id: niveau_id
        }).then(res => {
            setOrders(res.data.Matiere)
        })
    }
    const searchAll = async () => {
        setSelectCycle("")
        setSelectNiveau("")
        setSelectDepartement("")
        setSelectSpecialite("")
        setSelectSemestre("")
        const res = await API.get("matiere/list").then(res => {
            setOrders(res.data.Matiere)
        })
    }
    const getNiveau = async event => {
        var cycle_id = event.value
        setSelectCycle(event)
        setSelectNiveau("")
        setSelectSpecialite("")
        if (cycle_id == 1) {
            const res = await API.get("niveau/select").then(res => {
                setNiveau(res.data.Niveau)
            })
        } else {
            const res = await API.get("niveau/select_mastere").then(res => {
                setNiveau(res.data.Niveau)
            })
        }
    }

    const getSpec = async event => {
        var departement_id = event.value
        setSelectSpecialite("")
        setSelectDepartement(event)
        const res = await API.post("specialite/select_by_departement_cycle", {
            departement_id: departement_id,
            cycle_id: selectCycle.value,
        }).then(res => {
            setSpecialite(res.data.Specialite)
        })
    }
    return (
        <React.Fragment>
            <div>
                {loading ? (
                    <Row>
                        <Col xs="12">
                            <ToolkitProvider
                                keyField="id"
                                data={orders}
                                columns={Columns()}
                                search
                                bootstrap4
                            >
                                {toolkitProps => (
                                    <div>
                                        <CardTitle style={{color: "#556ee6"}} className="h4">
                                            Critéres de Recherches
                                        </CardTitle>
                                        <Form className="mt-4">
                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">Cycle : </Label>
                                                        <Select
                                                            options={cycle}
                                                            isSearchable={true}
                                                            value={selectCycle}
                                                            onChange={e => getNiveau(e)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">Niveau : </Label>
                                                        <Select
                                                            options={niveau}
                                                            isSearchable={true}
                                                            value={selectNiveau}
                                                            onChange={e => setSelectNiveau(e)}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-lastname-input2">Département :</Label>
                                                        <Select
                                                            options={departement}
                                                            isSearchable={true}
                                                            value={selectDepartement}
                                                            onChange={e => getSpec(e)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">Spécialité :</Label>
                                                        <Select
                                                            options={specialite}
                                                            isSearchable={true}
                                                            value={selectSpecialite}
                                                            onChange={e => setSelectSpecialite(e)}
                                                        />
                                                    </div>
                                                </Col>

                                            </Row>
                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">Semestre</Label>
                                                        <Select
                                                            options={semestre}
                                                            isSearchable={true}
                                                            value={selectSemestre}
                                                            onChange={e => setSelectSemestre(e)}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                        <div
                                            className="mb-4"
                                            style={{display: "flex", justifyContent: "space-around"}}
                                        >
                                            {" "}
                                            <Col lg="6">
                                                <div className="text-center mt-4">
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: "#761C19",
                                                            borderColor: "#761C19",
                                                        }}
                                                        className="btn btn-success mb-2 me-2"
                                                        onClick={search}
                                                    >
                                                        Rechercher
                                                    </button>
                                                </div>
                                            </Col>
                                            <Col lg="6">
                                                <div className="text-center mt-4">
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: "#761C19",
                                                            borderColor: "#761C19",
                                                        }}
                                                        className="btn btn-success mb-2 me-2"
                                                        onClick={searchAll}
                                                    >
                                                        Afficher tout
                                                    </button>
                                                </div>
                                            </Col>
                                        </div>
                                        <Col sm="4">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <SearchBar {...toolkitProps.searchProps} />
                                                    <i className="bx bx-search-alt search-icon"/>
                                                </div>
                                            </div>
                                        </Col>
                                        <BootstrapTable
                                            wrapperClasses="table-responsive"
                                            noDataIndication={() => <NoDataIndication/>}
                                            striped={false}
                                            bordered={false}
                                            classes={"table align-middle table-nowrap"}
                                            headerWrapperClasses={"table-light"}
                                            hover
                                            pagination={paginationFactory(pageOptions)}
                                            {...toolkitProps.baseProps}
                                        />
                                    </div>
                                )}
                            </ToolkitProvider>
                        </Col>
                    </Row>
                ) : (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {" "}
                            <Spinner type="grow" className="ms-6" color="primary"/>
                        </div>
                        <h4
                            style={{textAlign: "center", marginTop: "2%"}}
                            className="ms-6"
                        >
                            {" "}
                            En cours ...{" "}
                        </h4>
                    </div>
                )}
            </div>
            <Modal isOpen={modal} toggle={toggle} centered={true}>
                <ModalHeader
                    style={{width: "100% !important", textAlign: "center !important"}}
                    toggle={toggle}
                    tag="h4"
                >
                    {" Suppression d'une matière"}{" "}
                </ModalHeader>
                <ModalBody>
                    <div
                        style={{
                            fontFamily: "Montserrat, sans-serif",
                            FontSize: "14px",
                            FontWeight: "700",
                            LineHeight: "18.375px",
                        }}
                    >
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <p>Voulez-vous supprimer cette Matière ?</p>
                        </div>
                        <div
                            className="hvr-push"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                marginBottom: "15px",
                            }}
                        >
                            <div>
                                <Button
                                    color="info"
                                    className="btn-rounded "
                                    onClick={toggleDelete}
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-up"
                                    ></i>
                                    Oui
                                </Button>
                            </div>
                            <div>
                                <Button
                                    onClick={toggle}
                                    color="danger"
                                    className="btn-rounded "
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-down"
                                    ></i>
                                    Non
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default withRouter(DataTableMatiere)
DataTableMatiere.propTypes = {
    orders: PropTypes.array,
    history: PropTypes.object,
}
